import { Visitor } from './visitor-types';
import { ExplainedBusinessRulesConditions } from './business-rules-types';

export enum VisitorJourneyStepStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
}

export enum JourneyExpandPolicies {
  HOT = 'hot',
  ALWAYS = 'always',
}

export enum JourneyInitialDisplayModes {
  SKELETON = 'skeleton',
  CHAT = 'chat',
}

export enum JourneyEntryTypes {
  RULES = 'rules',
  API = 'api',
}

export interface VisitorJourney {
  id: number;
  visitorId: Visitor['sbid'];
  journeyId: number;
  journeyVersionId: number;
  conversationId?: number;
  introductionMessage?: string;
}

export interface JourneyTestResult {
  failureReason: 'conditions_failed' | 'other_matched_first';
  triggered: boolean;
  conditions: ExplainedBusinessRulesConditions;
  journeyId: number;
  normalJourneyId?: number;
}
